/** Period presets for the fleet dashboard. Dates are local calendar days as ISO `YYYY-MM-DD`. */
export type PeriodKey = 'THIS_MONTH' | 'LAST_30_DAYS' | 'LAST_MONTH';

export interface Period {
  from: string;
  to: string;
}

function iso(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function periodFor(key: PeriodKey, today: Date = new Date()): Period {
  const y = today.getFullYear();
  const m = today.getMonth();
  if (key === 'THIS_MONTH') return { from: iso(new Date(y, m, 1)), to: iso(today) };
  if (key === 'LAST_MONTH') return { from: iso(new Date(y, m - 1, 1)), to: iso(new Date(y, m, 0)) };
  const from = new Date(today);
  from.setDate(from.getDate() - 29);
  return { from: iso(from), to: iso(today) };
}
